'use client';

import { EventType } from '@/services/isomorphic/UserInteractionService';
import { FunctionComponent } from 'react';
import type { INavigation } from '@/services/models/Navigation/INavigation';
import { Link } from '../../../../../../core-ui/Link';
import { formatLinkName } from '../../utils';

import S from '../styles.base.module.scss';

interface IBlockLinkProps {
  /** A single block of navigation that contains an array of links. */
  block: INavigation;
  /** The name of the top-level navigation category (e.g. "Women"). */
  parentCategoryName?: string;
}

/**
 * Renders a single block of links, the final level of the navigation links.
 */
export const Block: FunctionComponent<IBlockLinkProps> = ({
  block,
  parentCategoryName
}) => {
  return (
    <div className={S.block}>
      {block.name && (
        <Link className={S.blockHeader} href={block.href}>
          {block.name}
        </Link>
      )}

      <ul className={S.blockLinks} role="menu">
        {block.categories?.map((link) => {
          return (
            <li
              key={link.id}
              onKeyDown={(event): void => {
                if (event.key === ' ' || event.key === 'Enter') {
                  event.stopPropagation();
                  if (event.key === ' ') {
                    event.preventDefault();
                  }
                }
              }}
              className={S.blockLinkWrapper}
              role="menuitem"
            >
              <Link
                className={S.blockLink}
                href={link.href}
                variant="base"
                interactionDetails={{
                  action: EventType.NavigationLink,
                  link: {
                    linkName: formatLinkName(parentCategoryName, link.name),
                    linkCategory: 'top-navigation',
                    linkSection: parentCategoryName?.toLowerCase() ?? block.name
                  }
                }}
              >
                {link.name}
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
